import "ckeditor.js"
import Controller from './admin/ckeditor_controller'
import '../stylesheets/admin.scss'
export default Controller